import script from "./VModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./VModal.vue?vue&type=script&setup=true&lang=ts"

import "./VModal.vue?vue&type=style&index=0&id=11f5e6b2&lang=postcss&scoped=true"

import exportComponent from "/builds/frontend/dsp/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11f5e6b2"]])

export default __exports__